import React, {useEffect} from "react";
import logoSlim from "../../../images/release/logo-slim.png"
import balloon from "../../../images/balloon.svg"
import "./HomePage.sass"
import PropTypes from "prop-types"
import courses from "../../../images/release/home_menu/girafa-courses.svg"
import teachers from "../../../images/release/home_menu/girafa-teachers.svg"
import collaboration from "../../../images/release/home_menu/girafa-collaboration.svg"
import about from "../../../images/release/home_menu/girafa-about.svg"
import {Link} from "react-router-dom";
import {ABOUT, COLLABORATION_PAGE, COURSES, TEACHERS} from "../../../common/links";

const MenuItem = (props) => {
    const {icon, name, url} = props

    return (
        <Link to={url || '/'} className="home-menu-item-wrapper">
            <img src={icon} alt={name}/>
            <div>{name}</div>
        </Link>
    )
}

MenuItem.propTypes = {
    icon: PropTypes.string.isRequired,
    name:PropTypes.string.isRequired,
    url:PropTypes.string,
}

export default function HomePage() {

    useEffect(() => {
        document.title = 'КьюАй - Центр детского развития';
    }, [])

    return (
        <div className="home-wrapper">
            <div className="home-container">
                <div className="home-logo-area-wrapper">
                    <div className="home-logo-area-words">
                        {/*<Logo/>*/}
                        <img src={logoSlim} alt="КьюАй"/>
                    </div>
                    <div className="home-logo-area-balloon">
                        <img src={balloon} alt="КьюАй"/>
                    </div>
                </div>
                <div className="home-menu-item">
                    <MenuItem url={COURSES} icon={courses} name="Курсы"/>
                    <MenuItem url={TEACHERS} icon={teachers} name="Методисты"/>
                    <MenuItem url={COLLABORATION_PAGE} icon={collaboration} name="Сотрудничество"/>
                    <MenuItem url={ABOUT} icon={about} name="О нас"/>
                </div>
            </div>
        </div>
    )
}